import React, { useState, useEffect } from 'react'

import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";

import { gql, useApolloClient } from '@apollo/client';
import { useDispatch } from 'react-redux';

import { AddBPMApplicationMessages } from '../../../redux/reducers/BPMReducer';
import BPMDialog from '../../../components/BPMTable/TableComponents/Dialogs/BPMDialog'

const RESEND_MAIL = gql`
    mutation(
        $id: String!, 
    ){
        bayphoneResendMail(
            id:$id, 
        ) {
            bayphone {
                id
            }
        }
    }
`;

const BayphoneResendMailDialog = props => {
    const [ isLoading, setLoading ] = useState(false);

    const { open, handleClose, selectedRows, t } = props;

    const dispatch = useDispatch()
    const client = useApolloClient()

    useEffect(() => {
        return () => {
            setLoading(false);
        };
    }, []);

    const onClickProcess = () => {
        setLoading(true)

        client.mutate({
            mutation: RESEND_MAIL,
            variables: {
                id: selectedRows[0].id,
            },
        })
        .then(result => {
            const success = result.data;
            
            if (success) {
                handleQueryExecuted(true, t("State change successfully executed"));
            } else {;
                handleQueryExecuted(false, t('An error occurred while changing the state of the Bayphone'));
            }
        })
        .catch(error => {
            handleQueryExecuted(false, JSON.stringify(error))
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const createApplicationMessage = (text, variant) => {
        dispatch(AddBPMApplicationMessages({
            text: text, 
            duration: 8000,
            variant: variant,
        }))
    }

    const handleQueryExecuted  = (success, message) => {
        createApplicationMessage(message, success ? 'success' : 'error');
        setLoading(false);
        onCloseDialog();
    }

    const onCloseDialog = () => {
        handleClose();
    }

    return (
        <BPMDialog 
        open={open} 
        onClose={onCloseDialog}
        maxWidth='md'
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        >
            <DialogTitle id='alert-dialog-title'>
                <span onClick={(event, reason) => onCloseDialog(event, reason)} style={{fontSize: '1.5em',  cursor: 'pointer', position: 'absolute', right: '5px', top: '-5px'}}>&times;</span>
                {t('bayphone:Bayphone')}
            </DialogTitle>
            <DialogContent>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-between' }}>
                <div>
                    <Button 
                        style={{ marginRight: 20 }}
                        onClick={onCloseDialog} 
                        variant='contained'
                        disabled={isLoading}
                    >
                        {t('bayphone:Cancel')}
                    </Button>
                    <Button
                        onClick={onClickProcess}
                        variant='contained'
                        color='primary'
                    >
                        {t('bayphone:Resend mail')}
                    </Button>
                </div>
            </DialogActions>
        </BPMDialog>
    )
};

export default BayphoneResendMailDialog;